export const LOADING_PLACEHOLDER_ID = 'loadingPlaceholder'
export const STICKY_NOTES_FRAME_ID = 'stickyNotesFrame'
